import { logger } from 'src/commons/utils/logger';

const UNDEFINED = 'undefined';

const undefinedUrlLogger = () => {
  try {
    // log initial page load if URL contains undefined
    if (window && window.location.href.includes(UNDEFINED)) {
      logger.debug(
        `[navigation] undefined detected in URL: ${window.location.href}`,
      );
    }

    // add listener for navigation.  This API is experimental and only works on Chrome and Edge
    // https://developer.mozilla.org/en-US/docs/Web/API/Navigation/navigate_event
    if (window && (window as any).navigation) {
      (window as any).navigation.addEventListener('navigate', (event) => {
        try {
          const currentUrl = window.location.href;
          const destinationUrl = event.destination.url;
          if (
            currentUrl.includes(UNDEFINED) ||
            destinationUrl.includes(UNDEFINED)
          ) {
            logger.debug(
              `[navigation] navigating from: ${currentUrl}, to: ${destinationUrl}`,
            );
          }
        } catch (navigationError: any) {
          logger.error(
            `[navigation] failed to log when navigating from url: ${window.location.href}`,
            navigationError,
          );
        }
      });
    }
  } catch (e: any) {
    logger.error(
      `[navigation] failed to log navigation for url: ${window.location.href}`,
      e,
    );
  }
};

export default undefinedUrlLogger;
